import { FC, memo } from "react";
import {
    AvatarGroup,
    type AvatarGroupSize,
} from "@design-system/Avatar/AvatarGroup";
import { CloseOverviewMember } from "@common/schemas/clientsCloseOverview.schema";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";

interface Props {
    members: CloseOverviewMember[];
    iconSize?: AvatarGroupSize;
    /** Map of userId → role labels (e.g. ["Preparer", "Manager"]) for tooltip enrichment. */
    rolesByUserId?: Map<number, string[]>;
}

const getMemberName = (member: CloseOverviewMember) =>
    member.preferredName ?? member.email ?? "";

export const CloseOverviewMemberList: FC<Props> = memo(
    ({ members, iconSize = "xs", rolesByUserId }) => (
        <AvatarGroup
            items={members}
            getKey={(member) => member.userId}
            getLabel={getMemberName}
            renderAvatar={(member) => (
                <AvatarTooltip
                    title={getMemberName(member)}
                    content={rolesByUserId?.get(member.userId)?.join(", ")}
                >
                    <UserAvatar
                        user={{
                            name: getMemberName(member),
                            email: member.email,
                            iconColor: member.iconColor,
                            avatar: member.avatar,
                        }}
                    />
                </AvatarTooltip>
            )}
            max={5}
            size={iconSize}
        />
    ),
);

CloseOverviewMemberList.displayName = "CloseOverviewMemberList";
